import type {CSSProperties} from 'react';
import {font, leading} from '../scale.js';
import {wedgeTextareaFieldStyle} from './wedgeTextareaField.js';

export type WedgeJournalEditVariant = 'wedge-journal-edit' | 'wedge-journal-edit-mobile';

export const isWedgeJournalEditVariant = (variant: unknown): variant is WedgeJournalEditVariant =>
  variant === 'wedge-journal-edit' || variant === 'wedge-journal-edit-mobile';

/* verbatim JournalEntryRow editor type on desktop, off-scale */
const DESK_FONT = 14.5;

/* Released inline editor of a journal entry (`JournalEntryRow` in the account journal: the Notes card in the brief, the desktop rail, the phone
   sheet and the Notes app): the note editor of the Saved row (`wedge-note-area`) in the type of the entry body. One bare native textarea at
   full width and border-box on the `--bg-elev` fill, with the `--label` ink, a `0.5px --accent` border, a `10px` radius, `10px 12px` padding,
   the `--font` family, `resize: vertical` and `outline: none`. The desktop look is `14.5px` type and the phone look is `16px` type, both at line
   height 1.45 (the Saved row editor is `16px` at 1.4, so it is not the same look). The user may drag the height. Focus is on mount and the
   caller owns it, with the value, `rows` (4), the handlers and the name. It reads the exact legacy roles, so the shipped ink rules keep
   matching, and it holds no focus look: the source sets `outline: none`, so it is kept as written and the shipped sheet draws the ring. */
export function wedgeJournalEditStyle(variant: WedgeJournalEditVariant): CSSProperties {
  const phone = variant === 'wedge-journal-edit-mobile';
  return {...wedgeTextareaFieldStyle('wedge-note-area'), fontSize: phone ? font.headline : DESK_FONT, lineHeight: leading.body};
}
